module.exports = __webpack_public_path__ + "img/load.fed17738.svg";